export default __webpack_public_path__ + "static/media/icon-delete-image.e0847e22.svg";